import './CartItem.scss';

import React from 'react';
import PropTypes from 'prop-types';

import Rails from '@rails/ujs';

import Currency from '../ui/elements/Currency';
import DeleteCartItem from '../ui/elements/buttons/Delete';
import InputQuantity from '../ui/form/InputQuantity';
import { obfuscateQuantity } from '../../library/parts';
import PartDescription from './part/PartDescription';

class CartItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      airDelivery: this.props.airDelivery,
      isDeleting: false,
      quantity: this.props.quantity,
      selected: this.props.selected === 'undefined' || this.props.selected,
    };

    this.handleDelete = this.handleDelete.bind(this);
    this.handleChangeAirDelivery = this.handleChangeAirDelivery.bind(this);
    this.handleChangeQuantity = this.handleChangeQuantity.bind(this);
    this.handleChangeSelected = this.handleChangeSelected.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.selected !== prevProps.selected) {
      this.setState({ selected: this.props.selected });
    }
  }

  get deliveryStatus() {
    if (this.props.source) {
      if (this.props.source.expectedDeliveryDate && this.props.source.expectedQuantity) {
        const date = new Date(this.props.source.expectedDeliveryDate);
        if (this.props.source.quantity > 0 && this.props.quantity <= this.props.source.quantity) {
          return this.props.source.deliveryTime;
        }
        else {
          return `Ожидается ${this.props.source.expectedQuantity}${'\u00A0'}шт. ${date.toLocaleString(undefined, {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          })}`;
        }
      } else {
        if (this.props.source.quantity <= 0) {
          return 'нет в наличии, под заказ'
        } else {
          return this.props.source.deliveryTime;
        }
      }
    }

    return null;
  }

  handleDelete() {
    this.setState({ isDeleting: true });
    fetch(`/cart_items/${this.props.id}`, {
      credentials: 'same-origin',
      headers: { 'X-CSRF-Token': Rails.csrfToken() },
      method: 'DELETE',
    })
      .then(function (response) {
        if (response.status >= 200 && response.status < 300) {
          return response;
        } else {
          const error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .then(() => {
        this.setState({ isDeleting: false });
        this.props.onDelete(this.props.id);
      })
      .catch((error) => {
        this.setState({ isDeleting: false });
        alert('При попытке удалить деталь возникла ошибка.');
      });
  }

  handleChangeAirDelivery(event) {
    this.setState({ isUpdating: true });

    const data = new FormData();
    data.append('cart_item[air_delivery]', event.target.checked);
    fetch(`/cart_items/${this.props.id}.json`, {
      body: data,
      credentials: 'same-origin',
      headers: { 'X-CSRF-Token': Rails.csrfToken() },
      method: 'PATCH',
    })
      .then(function (response) {
        if (response.status >= 200 && response.status < 300) {
          return response.json();
        } else {
          const error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .then((data) => {
        this.setState({ isUpdating: false, airDelivery: data.airDelivery, price: data.price, sum: data.sum });
        this.props.onChange(this.props.id, data);
      })
      .catch((error) => {
        this.setState({ isUpdating: false });
        alert('Произошла ошибка при попытке указать необходимость авиадоставки');
      });
  }

  handleChangeQuantity(value) {
    this.setState({ isUpdating: true });

    const data = new FormData();
    data.append('cart_item[quantity]', value);
    fetch(`/cart_items/${this.props.id}.json`, {
      body: data,
      credentials: 'same-origin',
      headers: { 'X-CSRF-Token': Rails.csrfToken() },
      method: 'PATCH',
    })
      .then(function (response) {
        if (response.status >= 200 && response.status < 300) {
          return response.json();
        } else {
          const error = new Error(response.statusText);
          error.response = response;
          throw error;
        }
      })
      .then((data) => {
        this.setState({ isUpdating: false, quantity: data.quantity, price: data.price, sum: data.sum });
        this.props.onChange(this.props.id, data);
      })
      .catch((error) => {
        this.setState({ isUpdating: false });
        alert('Произошла ошибка при попытке изменить количество деталей');
      });
  }

  handleChangeSelected(event) {
    this.setState({ selected: event.target.checked });
    this.props.onChangeSelected(this.props.id, event.target.checked);
  }

  render() {
    return (
      <React.Fragment>
        <tr className={`CartItem ${this.state.selected ? 'CartItem-selected' : ''}`} id={`CartItem_${this.props.id}`}>
          <td className="is-vertically-middle has-text-centered CartItem-td-with-text">{typeof this.props.index !== 'undefined' ? this.props.index + 1 : ''}</td>
          <td className="is-vertically-middle has-text-centered is-nowrapped CartItem-td-with-text">{this.props.part.brand.name}</td>
          <td className="is-vertically-middle has-text-centered is-nowrapped CartItem-td-with-text">
            <a href={this.props.employee ? `office/parts/${this.props.part.slug}` : `/parts/${this.props.part.slug}`}>{this.props.part.article}</a>
          </td>
          <td className="is-vertically-middle CartItem-td-with-text">
            <PartDescription
              available={true}
              description={this.props.part.description}
              comment={this.props.part.comment}
              packing={this.props.soldInPacks ? this.props.packingQuantity : undefined}
              replacement={this.props.part.replacement}
              supplied={this.props.supplied}
              weight={parseFloat(this.props.part.weight)}
            />
          </td>
          <td className="is-vertically-middle has-text-right is-nowrapped CartItem-td-with-text">
            {this.state.isUpdating && <div className="is-pulled-right loader" />}
            {!this.state.isUpdating && <Currency value={this.props.price} />}
            {this.props.rebateClauseId && <p className="has-text-danger-dark has-text-line-through is-size-7"><Currency value={this.props.clearPrice} /></p>}
          </td>
          <td className="is-vertically-middle has-text-centered CartItem-td-with-text" style={{ backgroundColor: this.props.color, color: this.props.textColor }}>
            {this.props.source && this.props.source.name}
          </td>
          <td className="is-vertically-middle has-text-centered CartItem-td-with-text">{this.props.source && obfuscateQuantity(this.props.source.quantity)}</td>
          <td className="is-vertically-middle CartItem-td-with-text has-text-centered">{this.deliveryStatus}</td>
          <td className="is-vertically-middle has-text-centered">
            <InputQuantity
              className={this.props.quantityWasChanged ? 'is-info has-text-centered' : 'has-text-centered'}
              limit={this.props.limitQuantity}
              minimum={this.props.minimumQuantity}
              name="cart_item[quantity]"
              quantity={this.state.quantity}
              step={(this.props.soldInPacks && !this.props.warrantyEmployee) ? this.props.packingQuantity : 1}
              onChangeQuantity={this.handleChangeQuantity}
              disabled={this.props.discarded}
            />
          </td>
          {this.props.showAirDelivery && (
            <td className="has-text-centered is-vertically-middle CartItem-td-with-text">
              {this.props.part.brand.airDelivery && !this.props.discarded && (
                <input type="checkbox" checked={this.state.airDelivery} onChange={this.handleChangeAirDelivery} />
              )}
            </td>
          )}
          <td className="has-text-right is-vertically-middle is-nowrapped CartItem-td-with-text">
            {this.state.isUpdating && <div className="is-pulled-right loader" />}
            {!this.state.isUpdating && <Currency value={this.props.sum} />}
          </td>
          <td className="has-text-centered is-vertically-middle">
            <DeleteCartItem
              classNames={[this.state.isDeleting ? 'is-loading' : '']}
              disabled={this.state.isDeleting}
              icon="trash"
              title="Удалить из корзины"
              onDelete={this.handleDelete}
              confirm={this.props.needConfirm ? `Вы уверены, что хотите удалить деталь ${this.props.part.slug} из корзины?` : ''}
            />
          </td>
          <td className="is-vertically-middle CartItem-td-with-checkbox">
            {!this.props.discarded && (
              <input
                type="checkbox"
                checked={this.state.selected}
                name="addToOrder"
                onChange={this.handleChangeSelected}
              />
            )}
          </td>
        </tr>
        {this.props.needReserveNote && this.props.reservedAnalog && (
          <tr className="has-text-weight-bold">
            <td></td>
            <td className="has-text-danger-dark is-vertically-middle" colSpan={this.props.showAirDelivery ? 13 : 12}>
              У вас в резерве есть аналогичные детали ({this.props.reservedAnalog.part}) в количестве {this.props.reservedAnalog.sum} шт.
            </td>
          </tr>
        )}
    </React.Fragment>
    );
  }
}

CartItem.propTypes = {
  airDelivery: PropTypes.bool.isRequired,
  id: PropTypes.number.isRequired,
  index: PropTypes.number,
  limitQuantity: PropTypes.number,
  maximumQuantity: PropTypes.number,
  minimumQuantity: PropTypes.number,
  packingQuantity: PropTypes.number,
  packingUnit: PropTypes.string,
  color: PropTypes.string,
  textColor: PropTypes.string,
  part: PropTypes.object.isRequired,
  price: PropTypes.number.isRequired,
  quantity: PropTypes.number.isRequired,
  selected: PropTypes.bool,
  showAirDelivery: PropTypes.bool,
  soldInPacks: PropTypes.bool,
  source: PropTypes.object,
  reservedAnalog: PropTypes.object,
  sum: PropTypes.number.isRequired,
  supplied: PropTypes.bool.isRequired,
  onDelete: PropTypes.func,
  onChange: PropTypes.func,
  onChangeSelected: PropTypes.func,
  quantityWasChanged: PropTypes.bool,
  discarded: PropTypes.bool,
  employee: PropTypes.bool,
  warrantyEmployee: PropTypes.bool,
  needConfirm: PropTypes.bool
};

export default CartItem;
